const promotion_card = () => {
    $('.promotion-card .popup').on('click', function(e) {
        e.preventDefault();
        console.log('promotion_card click');
        $(".popup.overlay").show();
    })

    $('.popup.overlay .close-button').on('click', function(e) {
        e.preventDefault();
        $(this).parent().parent().hide();
    });

    $('.promo-card-dropdown').on('change', function() {
        let href = $(this).val();
        
        window.open(href);
    });

    let placeholder = 'Select an option';

    $('.promo-card-dropdown').select2({
        placeholder: placeholder,
        selectionCssClass: 'custom-promo-card-select',
        dropdownCssClass: 'custom-promo-card-dropdown',
        width: '100%',
    });
}

export default promotion_card;